import { render, staticRenderFns } from "./duplicate-study.vue?vue&type=template&id=09520634&scoped=true&"
import script from "./duplicate-study.vue?vue&type=script&lang=js&"
export * from "./duplicate-study.vue?vue&type=script&lang=js&"
import style0 from "./duplicate-study.vue?vue&type=style&index=0&id=09520634&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09520634",
  null
  
)

component.options.__file = "duplicate-study.vue"
export default component.exports